import AbstractPeriodColumnSource from "./AbstractPeriodColumnSource.js";

/**
 * This class is used when a period column should fetch data from the
 * company's accounting data.
 */
export default class ActualsPeriodColumnSource extends AbstractPeriodColumnSource {}
